// TODO: If you make edits to this file you must deal with these ESLint rules
/*eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { graphql } from 'react-relay';

import { useSendBrokerInterestMutation as MutationParameters } from '@zego-types/useSendBrokerInterestMutation.graphql';
import useMutation, { Callbacks } from '@zego/mutations/useMutation';

const mutation = graphql`
  mutation useSendBrokerInterestMutation(
    $input: SendBrokerInterestInput!
  ) {
    sendBrokerInterest(
      input: $input
    ) {
      __typename
      ... on SendBrokerInterestSuccess {
        success
      }
      ... on SendBrokerInterestError {
        fieldErrors {
          fieldName
          errors
        }
      }
    }
  }
`;

export default function useSendBrokerInterestMutation(
  callbacks?: Callbacks<MutationParameters>,
) {
  return useMutation<MutationParameters>(mutation, callbacks);
}
